/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Suggested_ScheduleInputs */



/**
* | output |
* | --- |
* | "Suggested by the template. Change it or save it as is." |
*
* @param {Agent_Triggers_Suggested_ScheduleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_suggested_schedule = /** @type {((inputs?: Agent_Triggers_Suggested_ScheduleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Suggested_ScheduleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von der Vorlage vorgeschlagen. Ändern Sie ihn oder speichern Sie ihn so.")
	return /** @type {LocalizedString} */ ("Suggested by the template. Change it or save it as is.")
});